<div class="asc-menu-banner">
   <img src="/assets/images/ari-logo.svg" alt="asc-logo" />
</div>
<mat-nav-list>
   <mat-list-item (click)="navigateTo(homeEntryPoint)" [ngClass]="{'active-menu': isHomeActive()}">
      <mat-icon matListItemIcon class="material-symbols-rounded-filled">home</mat-icon>
      <span matListItemTitle>Startseite</span>
   </mat-list-item>

   <mat-divider />

   @for (featureNavigationItem of featureNavigationItems; track $index) {
   <div>
      @if (featureNavigationItem.entryPoints.length > 1) {
      <mat-list-item [matMenuTriggerFor]="menu" [ngClass]="{'active-menu': isFeatureActive(featureNavigationItem)}">
         <asc-module-icon matListItemIcon [primary]="featureNavigationItem.icons.primary" [secondary]="featureNavigationItem.icons.secondary"></asc-module-icon>
         <span matListItemTitle>{{featureNavigationItem.displayName}}</span>
      </mat-list-item>
      <mat-menu #menu="matMenu" [overlapTrigger]="true">
         @for (entryPoint of featureNavigationItem.entryPoints; track $index) {
         <button mat-menu-item (click)="navigateTo(entryPoint)" [ngClass]="{'asc-new-section': entryPoint.newSection,'active-menu': isFeatureActive(featureNavigationItem)}"
            [disabled]="(entryPoint.isEnabled) ? !entryPoint.isEnabled() : false">
            <asc-module-icon [primary]="entryPoint.icons?.primary" [secondary]="entryPoint.icons?.secondary">
            </asc-module-icon>
            {{entryPoint.displayName}}
         </button>
         }
      </mat-menu>
      }
      @else {
      <mat-list-item (click)="navigateTo(featureNavigationItem.entryPoints[0])" [ngClass]="{'active-menu': isFeatureActive(featureNavigationItem)}"
         [disabled]="(featureNavigationItem.entryPoints[0].isEnabled) ? !featureNavigationItem.entryPoints[0].isEnabled() : false">
         <asc-module-icon matListItemIcon [primary]="featureNavigationItem.icons.primary" [secondary]="featureNavigationItem.icons.secondary"></asc-module-icon>
         <span matListItemTitle>{{featureNavigationItem.displayName}}</span>
      </mat-list-item>
      }
   </div>
   }
</mat-nav-list>

@if (settingsNavigationItems.length > 0) {
<mat-divider />

<mat-nav-list>
   <mat-list-item (click)="navigateTo(settingsEntryPoint)" [ngClass]="{'active-menu': isSettingsActive()}">
      <mat-icon matListItemIcon class="material-symbols-rounded-filled">settings</mat-icon>
      <span matListItemTitle>Einstellungen</span>
   </mat-list-item>
</mat-nav-list>
}

<div class="asc-footer">
   <p>ARI - ASC {{version}}</p>
</div>